import {
  COMPONENT_VALUE_TYPES as types,
  BACKGROUND_IMAGE_POSITION,
  PERCENTAGES,
  COMPONENT_PARALLAX_SPEED
} from 'shared/constants';

const propsSchema = [
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'position',
        label: 'Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'background_color',
        label: 'Background Color',
        type: types.COLOR_PICKER
      },
      {
        key: 'scroll_in_animation',
        label: 'Scroll-In Animation',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'parallax_effect',
    label: 'Parallax Effect',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'enable',
        label: 'Enable',
        type: types.BOOLEAN
      },
      {
        key: 'speed',
        label: 'Speed',
        type: types.ENUM,
        options: COMPONENT_PARALLAX_SPEED
      }
    ]
  }
];

const defaultProps = {
  bg_img: {
    url: 'https://genesis-cdn.ff.com/product/04_interstitial/ff-91-driveway.jpg',
    position: 'CENTER CENTER',
    dark_overlay: 0,
    background_color: 'black',
    scroll_in_animation: false
  },
  parallax_effect: {
    enable: true,
    speed: 300
  }
};

export default {
  title: 'Transition Section',
  id: 'TransitionSection',
  propsSchema,
  defaultProps
};
